module.exports = __webpack_public_path__ + "img/homepage-bg.a82c63d7.png";